import {useCallback, useEffect, useState} from 'react';
import type {RefObject} from 'react';

export const useDragHover = (ref: RefObject<HTMLElement>) => {
    const [isDragHover, setIsDragHover] = useState<boolean>(false);

    const onDragOver = useCallback((e: Event) => {
        e.preventDefault();

        setIsDragHover(true);
    }, []);

    const onDragEnd = useCallback(
        (e: DragEvent) => {
            if (ref.current?.contains(e.relatedTarget as Node)) return;

            e.preventDefault();
            setIsDragHover(false);
        },
        [ref],
    );

    const onDrop = useCallback(() => {
        setIsDragHover(false);
    }, []);

    useEffect(() => {
        const node = ref.current;

        node?.addEventListener('dragover', onDragOver);
        node?.addEventListener('dragleave', onDragEnd);
        node?.addEventListener('dragend', onDragEnd);
        node?.addEventListener('drop', onDrop);

        return () => {
            node?.removeEventListener('dragover', onDragOver);
            node?.removeEventListener('dragleave', onDragEnd);
            node?.removeEventListener('dragend', onDragEnd);
            node?.removeEventListener('drop', onDrop);
        };
    }, [ref, onDragEnd, onDragOver, onDrop]);

    return isDragHover;
};
